import { render, staticRenderFns } from "./TemplateChooser.vue?vue&type=template&id=49f33b66&scoped=true"
import script from "./TemplateChooser.vue?vue&type=script&lang=js"
export * from "./TemplateChooser.vue?vue&type=script&lang=js"
import style0 from "./TemplateChooser.vue?vue&type=style&index=0&id=49f33b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f33b66",
  null
  
)

export default component.exports